import React, {useState} from 'react'
import gql from 'graphql-tag'

import Query from 'components/shared/Query'

const USER_QUERY = gql`
  query {
    viewer {
      id
      broker {
        id
        name
        email
      }
    }
  }
`

const CurrentUser = ({children}) => {
  const [cachedBroker, setCachedBroker] = useState({})

  if (cachedBroker.email) {
    return children({broker: cachedBroker})
  }

  return (
    <Query
      inlineError
      query={USER_QUERY}
      onCompleted={(data) => setCachedBroker(data.viewer.broker)}
    >
      {() => children({broker: cachedBroker})}
    </Query>
  )
}

export default CurrentUser
